import { API_URL } from "../utils/urls"; // PT-REACT-URLS v1
﻿

import React, { useEffect, useState } from 'react';
import { translate } from "../utils";
import { Link } from 'react-router-dom';
import LightGallery from 'lightgallery/react';
import lgVideo from 'lightgallery/plugins/video';
import axios from 'axios';


const DonationForm = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [campaignsLoading, setCampaignsLoading] = useState(true);
  const [imageDatanew, setImageDatanew] = useState([]);
  const [imageData1new, setImageData1new] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [imageData1, setImageData1] = useState([]);
  const [imageData2, setImageData2] = useState([]);
  const [imageData3, setImageData3] = useState([]);
  const [imageData4, setImageData4] = useState([]);
  const [imageData5, setImageData5] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchCampaigns = async () => {
      try {
        const response = await axios.get(
          API_URL + 'get_donation_campaigns'
        );

        if (isMounted && response.data?.error === "false") {
          setCampaigns(
            Array.isArray(response.data.data) ? response.data.data : []
          );
        }
      } catch (error) {
        console.error('Error fetching donation campaigns:', error);
      } finally {
        if (isMounted) {
          setCampaignsLoading(false);
        }
      }
    };

    fetchCampaigns();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL + 'get_gallery', {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const allImages = response.data.data;
        const cowImages = allImages.filter(image => image.type === "food-to-poor");
        setImageDatanew(cowImages);
        // setImageData(response.data.data);
        setImageData1new(cowImages.slice(0, 1));
        const cowImages3 = allImages.filter(image => image.type === "sugar");
        setImageData(cowImages3);
        setImageData1(cowImages3.slice(0, 1));
        const cowImages2 = allImages.filter(image => image.type === "cow");
        setImageData2(cowImages2);
        setImageData3(cowImages2.slice(0, 1));
        const cowImages4 = allImages.filter(image => image.type === "hindu");
        setImageData4(cowImages4);
        setImageData5(cowImages4.slice(0, 1));

      } catch (error) {
        console.error('Error fetching gallery data:', error);
      }
    };
    fetchData();
  }, []);
  return (
    
    <>
      <div className='container'>
        <div className='row mt-5 mb-5'>

          {campaignsLoading ? (
            <div className="col-12 text-center py-4">
              <p>Loading campaigns...</p>
            </div>
          ) : campaigns.length === 0 ? (
            <div className="col-12 text-center py-4">
              <p>No published campaigns are available right now.</p>
            </div>
          ) : (
            campaigns.map((campaign) => (
              <div className="col-lg-3 col-md-6 mb-4" key={campaign.id}>
                <div className="card donation-card h-100">
                  <Link
                    to={`/donate-campaign/${campaign.id}`}
                    className="text-decoration-none"
                  >
                    <img
                      src={campaign.image}
                      className="card-img-top"
                      alt={campaign.title || "Donation campaign"}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                      }}
                      onError={(event) => {
                        event.currentTarget.style.visibility = "hidden";
                      }}
                    />
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">
                        {campaign.title}
                      </h5>
                      <p className="card-text">
                        {campaign.description}
                      </p>
                      <span className="btn btn-primary mt-auto">
                        {translate("Donate")}
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            ))
          )}


         
         

        </div>
        
      </div>
    </>
  );
};
export default DonationForm;

